/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Form_Collect_Freight_LabelInputs */

const vi_order_form_collect_freight_label = /** @type {(inputs: Order_Form_Collect_Freight_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thu cước vận chuyển`)
};

/**

* @param {Order_Form_Collect_Freight_LabelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_form_collect_freight_label = /** @type {((inputs?: Order_Form_Collect_Freight_LabelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Form_Collect_Freight_LabelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_form_collect_freight_label(inputs)
});